import { render } from "./AdminDialogAcademicYearExpired.vue?vue&type=template&id=4f69749a"
const script = {}

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__